export const ROUTES = {
    ROOT: '/',
    LOGIN: '/login',
    INSPECTIONS: '/inspections',
    INSPECTION_START: '/inspections/:id/start',
    INSPECTION_DETAILS: '/inspections/:id',
    INSPECTION_MODULE: '/inspections/:id/:moduleName',
    // INSPECTION_HELPER: '/inspections/:id/:moduleName/:helperName',
    QUANTITY_CHECK: '/quantity-check',
    TOOLING: '/tooling',
    NOT_FOUND: '/not-found',
    FORBIDDEN: '/forbidden',
}